import React from 'react'
import { SWRConfig } from 'swr'

function Provider({ children }) {
    return (
        <SWRConfig
            value={{
                revalidateOnFocus: false,
                shouldRetryOnError: false,
            }}
        >
            {children}
        </SWRConfig>
    )
}

export default Provider